/** A new Stores issue of one kind. Nothing is written until the first item is posted. */
import { STORES_OUTBOUND_KINDS, storesOutbound } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { OutboundPage } from "@/features/stores/components/outbound-page";

export const Route = createFileRoute("/_app/stores/issues/new")({
  validateSearch: z.object({
    kind: z.enum(STORES_OUTBOUND_KINDS).default("issue_physical"),
    indent: z.number().int().positive().optional(),
  }),
  beforeLoad: ({ search }) => {
    if (
      !useAuth.getState().can(storesOutbound(search.kind).permission as never)
    )
      throw redirect({ to: "/stores/issues" });
  },
  component: Page,
});

function Page() {
  const { kind, indent } = Route.useSearch();
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <OutboundPage
      key={`${kind}-${indent ?? 0}`}
      doc={null}
      kind={kind}
      indentId={indent ?? null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
